import React, { useState, useEffect, forwardRef } from "react";
import { Input } from "@fragments";

const Title = forwardRef(function Title({ value, onInput }, ref) {
    const [_value, setValue] = useState(value);

    useEffect(() => {
        onInput(_value);
    }, [_value]);

    return (
        <Input.Text
            ref={ref}
            label="Título da aula"
            placeholder="Título da aula"
            size={100}
            value={_value}
            onInput={setValue}
            autoScroll
        />
    );
});

export default Title;
